export default __webpack_public_path__ + "80718c682c5b361fd6dfea8c1b1fb8a3.svg";